import type { FaireProductEntity } from "../../entity_types/product";

export const p_s39yqbk8sz: FaireProductEntity = {
  token: "p_s39yqbk8sz",
  type: "product",
  name: "Rainbow/Clear Cubic Zirconia Tennis Chain Necklace",
  brandToken: "b_4f46qpq5wu",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/175fdb5f8a03864824b5c1857566048b0e2293f8ec57a0c7ca4b36b52f2fff63.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c6a895e04194f9f1a2320af3f8138cc3c7dc4d51bc160d193e298c748111b2bc.jpeg",
    "https://cdn.faire.com/fastly/11e31405a8a06dd5f1b0bc2fa467dfab4f73e9240383afd9569dc1aa9a6ff3d1.jpeg",
    "https://cdn.faire.com/fastly/b993980aa9b8dd03e72e6caa51167618be00071cf8ed11623fef479da25d160f.jpeg",
    "https://cdn.faire.com/fastly/57f9252a9c7f100ecf02a465150a1af50e79894e1313ac5f3464b9b314abcb76.jpeg",
    "https://cdn.faire.com/fastly/0ed90f34209b2356a37d426fdb1b0827e323b720d1e5fe6fa1f68ae2500a6b7c.jpeg",
  ],
  priceDollars: 6.92,
  description:
    "\nThickness:3mm\nLength: 16inch\n\n3mm best quality cubic zirconia tennis chain, Handset stones\n",
  tags: [],
  msrpDollars: 13.83,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:26.856Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
